const formStyle = {
        control: (base: any, state: any) => ({
            ...base,
            backgroundColor: state.isDisabled ? "#7b7b7b" : "var(--input-color)",
            cursor: state.isDisabled ? "not-allowed" : "pointer",
            pointerEvents: "auto",
            boxShadow: "none",
            minHeight: "45px",
            borderRadius: "0px",
            border: state.isFocused ? "1px solid #191b1d" : "1px solid #c4c5c8",
            "&:hover": {
                borderColor: "#191b1d",
            },
        }),
        placeholder: (base: any, state:any) => ({
            ...base,
            color: state.isDisabled ? "#fff" : "var(--text-color)",
            backgroundColor: "transparent",
            fontSize: "14px",
        }),
        menu: (base: any) => ({
            ...base,
            overflowY: "auto",
            scrollbarWidth: "none",
            color: "var(--text-color)",
        }),
        menuList: (base: any) => ({
            ...base,
            maxHeight: "160px",
        }),
        menuPortal: (base: any) => ({
            ...base,
            zIndex: 3,
        }),
        option: (base: any, state: any) => ({
            ...base,
            backgroundColor: state.isFocused ? "#eee" : "",
            color: "var(--text-color)",
            fontSize: "100%",
            zIndex: 3,
        }),
        singleValue: (base: any, state: any) => ({
            ...base,
            color: state.selectProps.menuIsOpen ? "var(--text-color)" : state.isSelected ? "var(--text-color)" : "var(--text-color)",
        }),
        multiValueRemove: (base: any) => ({
            ...base,
            color: 'red',
        }),
        dropdownIndicator: (base: any) => ({
            ...base,
            color: "#191b1d",
        }),
    };

export default formStyle;